import { CEInterphaceAttributesBase } from './ce-interphace-attributes-base'


export class CEInterphaceAttributes extends CEInterphaceAttributesBase {

}